import { render } from "./AIconButton.vue?vue&type=template&id=046e83a2"
import script from "./AIconButton.vue?vue&type=script&lang=js"
export * from "./AIconButton.vue?vue&type=script&lang=js"

import "./AIconButton.vue?vue&type=style&index=0&id=046e83a2&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__